import type { ReactNode } from "react"

type ContactRowProps = {
  label: string
  children: ReactNode
}

export function ContactRow({ label, children }: ContactRowProps) {
  return (
    <div className="flex flex-col gap-2">
      <span className="font-mono font-semibold text-[10px] text-muted-foreground uppercase tracking-[0.4em]">
        {label}
      </span>
      {children}
    </div>
  )
}
